import React from "react";
import { INDUSTRIES } from "../data/site";
import useReveal from "../hooks/useReveal";
import { Layers } from "lucide-react";

const Industries = () => {
  const [ref, inView] = useReveal();
  return (
    <section
      id="industries"
      ref={ref}
      className={`relative py-28 bg-[#fffaf3] overflow-hidden reveal ${inView ? "in-view" : ""}`}
      data-testid="industries-section"
    >
      <div className="absolute -top-20 right-0 w-[400px] h-[400px] rounded-full bg-orange-400/20 blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-orange-100 border border-orange-200 text-orange-700 text-[10px] font-extrabold tracking-[0.25em] uppercase font-mono mb-5">
            <Layers className="w-3 h-3" /> Industries
          </div>
          <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl font-extrabold text-[#1a0a05] leading-[0.95] tracking-tight">
            Industries We <span className="text-heat brush">Deal In</span>.
          </h2>
          <p className="text-[#3a2418] mt-5 leading-relaxed max-w-2xl mx-auto">
            From food processing to electroplating, our heaters power a wide range of industrial applications across India and beyond.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-5xl mx-auto">
          {INDUSTRIES.map((ind, i) => (
            <div
              key={ind}
              data-testid={`industry-${i}`}
              className="group relative bg-white border border-orange-100 px-6 py-3.5 rounded-full text-sm font-semibold text-[#1a0a05] cursor-default lift overflow-hidden"
            >
              <span className="absolute inset-0 bg-gradient-to-r from-orange-50 to-amber-50 opacity-0 group-hover:opacity-100 transition-opacity" />
              <span className="relative">{ind}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Industries;
